import React, { lazy } from 'react';

import AuthContainer from '@/app/wrapper/AuthContainer';
import AppLayoutWrapper from 'app/wrapper/AppLayoutWrapper';
import AuthRoute from '../AuthRoute';

import NotFoundPage from '@/page/NotFoundPage';
import AbbvErrorPage from '@/page/AbbvErrorPage';
import AutoAuthPage from '@/page/authPage/autoAuth';
import WxAuthPage from '@/page/authPage/wxAuth';
import HomePage from '@/page/HomePage';
import WxAgreement from '@/page/mobile/wxAgreement';
import WxCodePage from '@/page/mobile/wxCodePage';
import WxSend from '@/page/mobile/wxSend';
import WxAuth from '@/page/mobile/wxAuth';
import InterceptViewConPage from '@/page/conversation/InterceptConPage/view';
import TravelInfSendPage from '@/page/admin/Journey/TravelInfSendPage';

import commonRoutes from './common';
import articleRoutes from './article';

import adminMenu from './menu-admin';
import appMenu from './menu-app';
import customerMenu from './menu-customer';
import conversationMenu from './menu-converstaion';
import { isDefaultCon } from '@/env';
import WxQrCode from '@/page/mobile/wxQrCode';
import QrCodeDemoPage from '@/page/mobile/QrCodeDemoPage';
import wechatMenu from './meun-wechat';

const IconsPage = lazy(() => import(/* webpackChunkName: "icons" */ '@/page/IconsPage'));
const ProfilePage = lazy(() => import(/* webpackChunkName: "profile" */ '@/page/ProfilePage'));
const ConversationPage = lazy(() =>
    import(/* webpackChunkName: "conversation" */ '@/page/conversation/ConPage')
);

const routeConfig = [
    {
        path: '/',
        element: (
            <AuthContainer>
                <AppLayoutWrapper />
            </AuthContainer>
        ),
        children: [
            { index: true, element: <HomePage /> },

            adminMenu,
            appMenu,
            customerMenu,
            wechatMenu,
            isDefaultCon() && conversationMenu,

            {
                path: 'conversation',
                element: (
                    <AuthRoute onAuthorities={['global:conversation:r', 'global:conversation:w']}>
                        <ConversationPage />
                    </AuthRoute>
                ),
            },
            {
                path: 'view/intercept',
                element: <InterceptViewConPage />,
            },

            {
                path: 'profile/*',
                element: <ProfilePage />,
            },
            // {
            //     path: '/docs',
            //     element: <DocView />,
            // },
            // {
            //     path: '/docs/view',
            //     element: <View />,
            // },
            {
                path: 'dev/icons',
                element: <IconsPage />,
            },
        ],
    },

    ...commonRoutes,
    ...articleRoutes,
    {
        path: 'wx/autoauth/*',
        element: <AutoAuthPage />,
    },
    {
        path: 'wx/auth/*',
        element: <WxAuthPage />,
    },
    {
        path: 'wx/mobile/agreement',
        element: <WxAgreement />,
    },
    {
        path: 'wx/mobile/qr',
        element: <WxQrCode />,
    },
    {
        path: 'wx/mobile/qrdemo',
        element: <QrCodeDemoPage />,
    },
    {
        path: 'wx/mobile/code',
        element: <WxCodePage />,
    },
    {
        path: 'wx/mobile/send',
        element: <WxSend />,
    },
    {
        path: 'wx/mobile/auth',
        element: <WxAuth />,
    },
    {
        path: 'wx/travelings/*',
        element: <TravelInfSendPage />,
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
    {
        path: 'error',
        element: <AbbvErrorPage />,
    },
].filter(Boolean);

export default routeConfig;
